import { FormArray, FormControl, FormGroup } from "@angular/forms";

import { BulkAddCustomFieldFormGroup } from "@components/shared/bulk-add/bulk-add.interface";
import { TextConstants } from "@shared/constants";
import { ISelectOption, ITagExtended } from "@shared/interfaces";

export namespace BulkAddProductsModel {
  export interface IProductFieldSharedFormGroup {
    [FieldEnum.TAGS]: FormControl<ITagExtended[]>;
    [FieldEnum.BASE_UNIT]: FormControl<ISelectOption>;
    [FieldEnum.ALLOWED_MATERIALS]: FormControl<ISelectOption[]>;
    [FieldEnum.HS_CODE]: FormControl<string>;
    [FieldEnum.DESCRIPTION]: FormControl<string>;
    [FieldEnum.CUSTOM_FIELDS]?: FormArray<FormGroup<BulkAddCustomFieldFormGroup>>;
  }

  export interface SetValuesFormGroup extends IProductFieldSharedFormGroup {
    [FieldEnum.IS_FIXED_TAGS]: FormControl<boolean>;
    [FieldEnum.IS_FIXED_BASE_UNIT]: FormControl<boolean>;
    [FieldEnum.IS_FIXED_ALLOWED_MATERIALS]: FormControl<boolean>;
    [FieldEnum.IS_FIXED_HS_CODE]: FormControl<boolean>;
    [FieldEnum.IS_FIXED_DESCRIPTION]: FormControl<boolean>;
    [FieldEnum.RECORDS]: FormArray<FormGroup<ProductFormGroup>>;
  }

  export interface ProductFormGroup extends IProductFieldSharedFormGroup {
    [FieldEnum.NAME]: FormControl<string>;
    [FieldEnum.IS_NAME_DUPLICATED]: FormControl<boolean>;
  }

  export enum FieldEnum {
    NAME = "name",
    TAGS = "tags",
    BASE_UNIT = "baseUnit",
    ALLOWED_MATERIALS = "allowedMaterials",
    HS_CODE = "hsCode",
    DESCRIPTION = "description",
    IS_FIXED_TAGS = "isFixedTags",
    IS_FIXED_BASE_UNIT = "isFixedBaseUnit",
    IS_FIXED_ALLOWED_MATERIALS = "isFixedAllowedMaterials",
    IS_FIXED_HS_CODE = "isFixedHsCode",
    IS_FIXED_DESCRIPTION = "isFixedDescription",
    IS_NAME_DUPLICATED = "isNameDuplicated",
    RECORDS = "records",
    CUSTOM_FIELDS = "customFields",
  }

  export const fieldEnumToLabelMap: Partial<Record<FieldEnum, string>> = {
    [FieldEnum.NAME]: TextConstants.NAME,
    [FieldEnum.TAGS]: `${TextConstants.TAGS} (${TextConstants.OPTIONAL})`,
    [FieldEnum.BASE_UNIT]: TextConstants.MAIN_MEASUREMENT_TYPE,
    [FieldEnum.ALLOWED_MATERIALS]: `${TextConstants.ALLOWED_MATERIALS} (${TextConstants.OPTIONAL})`,
    [FieldEnum.HS_CODE]: `${TextConstants.HS_CODE} (${TextConstants.OPTIONAL})`,
    [FieldEnum.DESCRIPTION]: `${TextConstants.DESCRIPTION} (${TextConstants.OPTIONAL})`,
  };

  export enum StepsEnum {
    SET_VALUES = 0,
    ENTER_RECORDS = 1,
    CREATE_RECORDS = 2,
  }
}
